import { render, staticRenderFns } from "./payment_partner_component.vue?vue&type=template&id=9270d970&scoped=true"
import script from "./payment_partner_component.vue?vue&type=script&lang=js"
export * from "./payment_partner_component.vue?vue&type=script&lang=js"
import style0 from "./payment_partner_component.vue?vue&type=style&index=0&id=9270d970&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9270d970",
  null
  
)

export default component.exports